import { verifyHostBindings } from '@angular/compiler';
import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { HttpClient, HttpHeaders, HttpParams, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ViewEncapsulation } from '@angular/core';
import { interval } from 'rxjs';

@Component({
  selector: 'app-adminmenu',
  templateUrl: './adminmenu.component.html',
  styleUrls: ['./adminmenu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminmenuComponent implements OnInit {

  ShownAudit: boolean = true;
  ShownAuditFilrUpload: boolean = true;
  ShownAuditFilrOutput: boolean = true;
  ShownClientFileUpload: boolean = true;
  ShownOnboarding: boolean = true;
  ShownContracts: boolean = true;
  ShownNDA: boolean = true;
  ShownEmployee: boolean = true;
  ShownAssignEmp: boolean = true;
  ShownParts: boolean = true;
  ShownLicence: boolean = true;
  ShownBond: boolean = true;
  ShownBank: boolean = true;
  ShownImportPart: boolean = true;
  ShownUserRights: boolean = true;
  ShownChaMaster: boolean = true;
  ShownCountryMaster: boolean = true;
  ShownCurrencyMaster: boolean = true;
  ShownExchangeMaster: boolean = true;
  ShownPortMaster: boolean = true;
  ShownNotify: boolean = true;
  ShownCustoms: boolean = true;
  ShownExim: boolean = true;
  ShownAntiDumping: boolean = true;
  ShownReport:boolean=true;
  Customers = [];
  CustomersOld = [];
  onboardingId: string;
  corporateName: string;
  Username: string;
  Rolename: string;
  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    var vUserName = localStorage.getItem("UserName");
    this.Username = vUserName;
    var vRoleName = localStorage.getItem("RoleName");
    this.Rolename = vRoleName;
    debugger;
    var vLoginId = localStorage.getItem("LoginId");
    if (vLoginId == undefined || vLoginId == "") {
      window.location.href = '/';
    }
    $(".menu-item1").click(function () {
      debugger;
      var vClass = (document.getElementById('ui-basic') as HTMLInputElement).className;
      if (vClass == "collapse") {
        (document.getElementById('ui-basic') as HTMLInputElement).className = 'collapse show';
      }
      else if (vClass == "collapse show") {
        (document.getElementById('ui-basic') as HTMLInputElement).className = 'collapse';
      }

      //   $(this).find('div').toggleClass('show');

      // $(this).find('div').removeClass('in');

    });
    $(".menu-item2").click(function () {
      debugger;
      var vClass = (document.getElementById('ui-basic1') as HTMLInputElement).className;
      if (vClass == "collapse") {
        (document.getElementById('ui-basic1') as HTMLInputElement).className = 'collapse show';
      }
      else if (vClass == "collapse show") {
        (document.getElementById('ui-basic1') as HTMLInputElement).className = 'collapse';
      }
    });
    $(".menu-item3").click(function () {
      debugger;
      var vClass = (document.getElementById('ui-basic2') as HTMLInputElement).className;
      if (vClass == "collapse") {
        (document.getElementById('ui-basic2') as HTMLInputElement).className = 'collapse show';
      }
      else if (vClass == "collapse show") {
        (document.getElementById('ui-basic2') as HTMLInputElement).className = 'collapse';
      }
    });
    $(".menu-item4").click(function () {
      debugger;
      var vClass = (document.getElementById('ui-basic3') as HTMLInputElement).className;
      if (vClass == "collapse") {
        (document.getElementById('ui-basic3') as HTMLInputElement).className = 'collapse show';
      }
      else if (vClass == "collapse show") {
        (document.getElementById('ui-basic3') as HTMLInputElement).className = 'collapse';
      }
    });

    this.ShowHideMenu();
    this.BindCustomerDDL();
    this.onboardingId = "0";
    localStorage.setItem ('corporateName',this.corporateName);
    localStorage.setItem('OnboardingId', this.onboardingId);
    this.ShownReport=false;

    interval(10000).subscribe(x => {
      this.BindCustomerDDL();
    });
    //debugger;
    // var vUserType = localStorage.getItem("UserType");
    // if (vUserType == "Admin") {
    //   this.ShownAuditFilrUpload = false;
    //   this.ShownClientFileUpload = true;
    //   this.ShownMasterFileUpload = false;
    //   this.ShownNotifyFileUpload = false;
    //   this.ShownChaMaster = false;
    //   this.ShownCountryMaster = false;
    //   this.ShownCurrencyMaster = false;
    //   this.ShownExchangeMaster = false;
    //   this.ShownPortMaster = false;
    // }
    // else if (vUserType == "Client") {
    //   this.ShownAuditFilrUpload = true;
    //   this.ShownClientFileUpload = false;
    //   this.ShownMasterFileUpload = true;
    //   this.ShownNotifyFileUpload = true;
    //   this.ShownChaMaster = true;
    //   this.ShownCountryMaster = true;
    //   this.ShownCurrencyMaster = true;
    //   this.ShownExchangeMaster = true;
    //   this.ShownPortMaster = true;
    // }
    // else if (vUserType == "Employee") {
    //   this.ShownAuditFilrUpload = false;
    //   this.ShownClientFileUpload = true;
    //   this.ShownMasterFileUpload = false;
    //   this.ShownNotifyFileUpload = false;
    //   this.ShownChaMaster = false;
    //   this.ShownCountryMaster = false;
    //   this.ShownCurrencyMaster = false;
    //   this.ShownExchangeMaster = false;
    //   this.ShownPortMaster = false;
    // }
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }
  LogoutClick() {
    localStorage.clear();
    window.location.href = '/';
  }
  ShowHideMenu() {
    debugger;
    var vRead = localStorage.getItem('AduitUploadRead');
    var vWrite = localStorage.getItem('AduitUploadWrite');
    if ((vRead != undefined && vRead != null && vRead != "") || (vWrite != undefined && vWrite != null && vWrite != ""))
      this.ShownAuditFilrUpload = false;

    var vReadAuditOutPut = localStorage.getItem('AuditOutputRead');
    var vWriteAuditOutPut = localStorage.getItem('AuditOutputWrite');
    if ((vReadAuditOutPut != undefined && vReadAuditOutPut != null && vReadAuditOutPut != "") || (vWriteAuditOutPut != undefined && vWriteAuditOutPut != null && vWriteAuditOutPut != ""))
      this.ShownAuditFilrOutput = false;

    if (this.ShownAuditFilrUpload == true && this.ShownAuditFilrOutput == true)
      this.ShownAudit = true;
    else
      this.ShownAudit = false;

    var vReadCha = localStorage.getItem('ChaRead');
    var vWriteCha = localStorage.getItem('ChaWrite');
    if ((vReadCha != undefined && vReadCha != null && vReadCha != "") || (vWriteCha != undefined && vWriteCha != null && vWriteCha != ""))
      this.ShownChaMaster = false;


    var vReadCountry = localStorage.getItem('CountryRead');
    var vWriteCountry = localStorage.getItem('CountryWrite');
    if ((vReadCountry != undefined && vReadCountry != null && vReadCountry != "") || (vWriteCountry != undefined && vWriteCountry != null && vWriteCountry != ""))
      this.ShownCountryMaster = false;

    var vReadCurrency = localStorage.getItem('CurrencyRead');
    var vWriteCurrency = localStorage.getItem('CurrencyWrite');
    if ((vReadCurrency != undefined && vReadCurrency != null && vReadCurrency != "") || (vWriteCurrency != undefined && vWriteCurrency != null && vWriteCurrency != ""))
      this.ShownCurrencyMaster = false;

    var vReadExchange = localStorage.getItem('ExchangeRead');
    var vWriteExchange = localStorage.getItem('ExchangeWrite');
    if ((vReadExchange != undefined && vReadExchange != null && vReadExchange != "") || (vWriteExchange != undefined && vWriteExchange != null && vWriteExchange != ""))
      this.ShownExchangeMaster = false;


    var vReadPort = localStorage.getItem('PortRead');
    var vWritePort = localStorage.getItem('PortWrite');
    if ((vReadPort != undefined && vReadPort != null && vReadPort != "") || (vWritePort != undefined && vWritePort != null && vWritePort != ""))
      this.ShownPortMaster = false;

    var vReadCustom = localStorage.getItem('CustomRead');
    var vWriteCustom = localStorage.getItem('CustomWrite');
    if ((vReadCustom != undefined && vReadCustom != null && vReadCustom != "") || (vWriteCustom != undefined && vWriteCustom != null && vWriteCustom != ""))
      this.ShownCustoms = false;

    var vReadExim = localStorage.getItem('EximRead');
    var vWriteExim = localStorage.getItem('EximWrite');
    if ((vReadExim != undefined && vReadExim != null && vReadExim != "") || (vWriteExim != undefined && vWriteExim != null && vWriteExim != ""))
      this.ShownExim = false;

    var vReadAntiDumbing = localStorage.getItem('AntiDumbingRead');
    var vWriteAntiDumbing = localStorage.getItem('AntiDumbingWrite');
    if ((vReadAntiDumbing != undefined && vReadAntiDumbing != null && vReadAntiDumbing != "") || (vWriteAntiDumbing != undefined && vWriteAntiDumbing != null && vWriteAntiDumbing != ""))
      this.ShownAntiDumping = false;

    if (this.ShownCustoms == true && this.ShownExim == true && this.ShownAntiDumping == true)
      this.ShownNotify = true;
    else
      this.ShownNotify = false;

    var vReadClient = localStorage.getItem('ClientRead');
    var vWriteClient = localStorage.getItem('ClientWrite');
    if ((vReadClient != undefined && vReadClient != null && vReadClient != "") || (vWriteClient != undefined && vWriteClient != null && vWriteClient != ""))
      this.ShownClientFileUpload = false;

    var vReadOnboarding = localStorage.getItem('OnboardingRead');
    var vWriteOnboarding = localStorage.getItem('OnboardingWrite');
    if ((vReadOnboarding != undefined && vReadOnboarding != null && vReadOnboarding != "") || (vWriteOnboarding != undefined && vWriteOnboarding != null && vWriteOnboarding != ""))
      this.ShownOnboarding = false;

    var vReadContracts = localStorage.getItem('ContractsRead');
    var vWriteContracts = localStorage.getItem('ContractsWrite');
    if ((vReadContracts != undefined && vReadContracts != null && vReadContracts != "") || (vWriteContracts != undefined && vWriteContracts != null && vWriteContracts != ""))
      this.ShownContracts = false;

    var vReadNda = localStorage.getItem('NdaRead');
    var vWriteNda = localStorage.getItem('NdaWrite');
    if ((vReadNda != undefined && vReadNda != null && vReadNda != "") || (vWriteNda != undefined && vWriteNda != null && vWriteNda != ""))
      this.ShownNDA = false;

    var vReadEmployee = localStorage.getItem('EmployeeRead');
    var vWriteEmployee = localStorage.getItem('EmployeeWrite');
    if ((vReadEmployee != undefined && vReadEmployee != null && vReadEmployee != "") || (vWriteEmployee != undefined && vWriteEmployee != null && vWriteEmployee != ""))
      this.ShownEmployee = false;

    var vReadAssignEmp = localStorage.getItem('AssignEmpRead');
    var vWriteAssignEmp = localStorage.getItem('AssignEmpWrite');
    if ((vReadAssignEmp != undefined && vReadAssignEmp != null && vReadAssignEmp != "") || (vWriteAssignEmp != undefined && vWriteAssignEmp != null && vWriteAssignEmp != ""))
      this.ShownAssignEmp = false;

    var vReadParts = localStorage.getItem('PartsRead');
    var vWriteParts = localStorage.getItem('PartsWrite');
    if ((vReadParts != undefined && vReadParts != null && vReadParts != "") || (vWriteParts != undefined && vWriteParts != null && vWriteParts != ""))
      this.ShownParts = false;


    var vReadLicense = localStorage.getItem('LicenseRead');
    var vWriteLicense = localStorage.getItem('LicenseWrite');
    if ((vReadLicense != undefined && vReadLicense != null && vReadLicense != "") || (vWriteLicense != undefined && vWriteLicense != null && vWriteLicense != ""))
      this.ShownLicence = false;

    var vReadBond = localStorage.getItem('BondRead');
    var vWriteBond = localStorage.getItem('BondWrite');
    if ((vReadBond != undefined && vReadBond != null && vReadBond != "") || (vWriteBond != undefined && vWriteBond != null && vWriteBond != ""))
      this.ShownBond = false;

    var vReadBank = localStorage.getItem('BankRead');
    var vWriteBank = localStorage.getItem('BankWrite');
    if ((vReadBank != undefined && vReadBank != null && vReadBank != "") || (vWriteBank != undefined && vWriteBank != null && vWriteBank != ""))
      this.ShownBank = false;

    var vReadImportPart = localStorage.getItem('ImportPartRead');
    var vWriteImportPart = localStorage.getItem('ImportPartWrite');
    if ((vReadImportPart != undefined && vReadImportPart != null && vReadImportPart != "") || (vWriteImportPart != undefined && vWriteImportPart != null && vWriteImportPart != ""))
      this.ShownImportPart = false;

    var vReadUserRights = localStorage.getItem('UserRightsRead');
    var vWriteUserRights = localStorage.getItem('UserRightsWrite');
    if ((vReadUserRights != undefined && vReadUserRights != null && vReadUserRights != "") || (vWriteUserRights != undefined && vWriteUserRights != null && vWriteUserRights != ""))
      this.ShownUserRights = false;
  }
  Show(event: any) {
    debugger;
    this.onboardingId = event.target.value;
    localStorage.setItem('OnboardingId', this.onboardingId);
    let params = new HttpParams();
    params = params.append('iOnboardingId', this.onboardingId);
    var value = this.http.get(environment.apiUrl + 'Login/GetCustomerName', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        this.corporateName = data["0"].corporateName;
        var vAddressLine2=data["0"].addressLine2;
        localStorage.setItem ('corporateName',this.corporateName);
        localStorage.setItem ('corporateAddress2',vAddressLine2);
      });

  }

  BindCustomerDDL() {
    var vRoleName = localStorage.getItem("RoleName");
    var vEmployeeId = localStorage.getItem("EmployeeId");
    if (vEmployeeId == undefined || vEmployeeId == null || vEmployeeId == "null")
      vEmployeeId = "0";
    let params = new HttpParams();
    params = params.append('sType', vRoleName);
    params = params.append('iId', vEmployeeId);
    var value = this.http.get(environment.apiUrl + 'Login/GetCustomerForDDL', { params: params }).toPromise().then(
      (data: any) => {
        //debugger;
        if (this.Customers == undefined || this.Customers == null || this.Customers == [] || this.Customers.length==0) {
          this.Customers = data;
          this.CustomersOld = data;
        }
        else {
         var Customers1 =[];
         Customers1=data;
          if (this.CustomersOld.length == Customers1.length) { }
          else{
            this.Customers = data;
            this.CustomersOld = data;
            this.onboardingId="0";
            this.corporateName="";
            localStorage.setItem ('corporateName',this.corporateName);
          }
        }
        // if (this.onboardingId != undefined && this.onboardingId != null && this.onboardingId != "" && this.onboardingId != "0") {
        //   var vonboardId = this.onboardingId;
        //   interval(5000).subscribe(x => {
        //     debugger;
        //     this.onboardingId = vonboardId;
        //   });
        //   localStorage.setItem('OnboardingId', vonboardId);
        // }
      });
  }
}
